/*
    this.paymentMethods = [
      { id: PaymentMethod.Cash, title: this.$t("paymentMethods.cash") },
      { id: PaymentMethod.Card, title: this.$t("paymentMethods.card") },
      { id: PaymentMethod.Online, title: "MercadoPago" },
      { id: PaymentMethod.RedSys, title: "Tarjeta / Bizum" },
      { id: PaymentMethod.MetroBank, title: "Pago Online" },
      { id: PaymentMethod.CyberSource, title: "Pago Online" }
    ];*/

import { PaymentMethod } from '../enums/PaymentMethod';

export interface IPaymentMethod {
  id: PaymentMethod;
  icon: string;
  title: string;
  isOnline: boolean;
  countries?: string[];
}

export const PAYMENT_METHODS: IPaymentMethod[] = [
  {
    id: PaymentMethod.Cash,
    icon: 'mdi-cash',
    title: 'Efectivo',
    isOnline: false,
  },
  {
    id: PaymentMethod.Card,
    icon: 'mdi-credit-card',
    title: 'Tarjeta',
    isOnline: false,
  },
  {
    id: PaymentMethod.QR,
    icon: 'mdi-qrcode',
    title: 'QR',
    isOnline: false,
  },
  {
    id: PaymentMethod.BankTransfer,
    icon: 'mdi-bank-transfer',
    title: 'Transferencia',
    isOnline: false,
  },
  {
    id: PaymentMethod.Online,
    icon: 'mdi-web',
    title: 'MercadoPago',
    countries: ['AR'],
    isOnline: true,
  },
  {
    id: PaymentMethod.CustomerAccount,
    icon: 'mdi-account',
    title: 'Cuenta cliente',
    isOnline: false,
  },
  {
    id: PaymentMethod.Invitation,
    icon: 'mdi-account',
    title: 'Invitación',
    isOnline: false,
  },
  {
    id: PaymentMethod.Employee,
    icon: 'mdi-account',
    title: 'Empleado',
    isOnline: false,
  },
];

export const PAYMENT_METHODS_MAP = new Map<number, IPaymentMethod>([
  ...PAYMENT_METHODS.map((t): [number, IPaymentMethod] => [t.id, t]),
  // Display-only (NOT in PAYMENT_METHODS: never a selectable tender in
  // pickers — ModalPay builds its own club tile). Labels club-balance
  // payment rows in payments lists and printed resumes.
  [
    PaymentMethod.Club,
    {
      id: PaymentMethod.Club,
      icon: 'mdi-star-circle',
      title: 'Saldo Club',
      isOnline: false,
    },
  ],
]);
